import actions from './actions';

const initState = {
    promotion   : {},
    loading : false,
    errorMessage: null
};

export default function createOrUpdatePromotionReducer(state = initState, action) {
    switch (action.type) {
        case actions.CREATE_OR_UPDATE_PROMOTION_REQUESTED:
            return {
                ...state,
                promotion   : {},
                loading : false
            };
        case actions.CREATE_OR_UPDATE_PROMOTION_SUCCEEDED:
            return {
                ...state,
                promotion   : action.promotion,
                loading    : false
            };
        case actions.CREATE_OR_UPDATE_PROMOTION_FAILED:
            return {
                ...state,
                loading : false,
                errorMessage: action.error
            };
        default:
            return state;
    }
}
